import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import { WizardContextProvider } from '../../Services/WizardContext';
import PostWizard from './PostWizard';

loadDOMComponent({
	selector: 'react-post-wizard',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const wizardKey = container.getAttribute('wizardKey');
		const type = container.getAttribute('type');
		const data = JSON.parse(container.getAttribute('data') || '[]');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<WizardContextProvider>
						<PostWizard wizardKey={wizardKey} type={type} data={data} />
					</WizardContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
